import React from "react";
import { useState, useEffect } from "react";
import { useQueryClient } from "react-query";
import "../../scss/dashboard/crearplantilla.css";
import { FormProvider, useForm } from "react-hook-form";
import { useHistory, useParams } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

import {
  useFetchPublicTemplate,
  useUpdatePublicTemplate,
} from "../../api/hooks/public-templates";
import { PublicTemplateForm } from "./PublicTemplateForm";

function EditarPlantilla() {
  const [step, setStep] = useState(0);
  let history = useHistory();
  let { templateId } = useParams();

  const { data = {} } = useFetchPublicTemplate(templateId, undefined, {
    refetchOnWindowFocus: false,
  });
  const { mutate: updatePublicTemplateMutate } = useUpdatePublicTemplate();
  const template = data?.data;

  const handleNextStep = () => {
    // setStep(step => step + 1)
  };
  const handleSave = (data) => {
    console.log({ data });
    data.templateId = templateId;
    data.type = template.type;
    updatePublicTemplateMutate(data);
  };

  return (
    <div className="abogados__crearPlantilla editTemplateDash">
      <div className="abogados__crearPlantilla--h3 editTemplateHeader">
        <div>
          <div onClick={() => history.goBack()} className="EditTempletaGoBack">
            <FontAwesomeIcon icon={faArrowLeft} color="#f37b33" />
          </div>

          <h3>Editar Plantilla</h3>
        </div>

        <p>{template?.name}</p>
      </div>

      <div className="EditTemplateContent">
        <div className="EditaTemplateNavBar">
          <div
            onClick={() => setStep(0)}
            className={step === 0 ? "editActiveButton" : ""}
          >
            <span>Datos Basicos</span>
          </div>
          <div
            onClick={() => setStep(1)}
            className={step === 1 ? "editActiveButton" : ""}
          >
            <span>Configuración de Plantilla</span>
          </div>
          {/* <div
              onClick={() => setStep(2)}
              className={step === 2 ? "editActiveButton" : ""}
            >
              <span>Datos de Pago</span>
            </div> */}
        </div>

        <div className="Plantilla--container--form EditTemplateFormContainer">
          <section className="plantillasConfig">
            <PublicTemplateForm
              currentStep={step}
              defaultValues={template}
              onNextStep={handleNextStep}
              onSave={handleSave}
              saveMode="every"
              lastStep={1}
            />
          </section>
        </div>
      </div>
    </div>
  );
}

export default EditarPlantilla;
